import {IAttributes, IAugmentedJQuery, IDirective, IScope} from "angular";
import {sisteElementEtter, somAsciiSmåBokstaver} from "../tjenester/Strenger";

const s = require('./entitetIkon.scss');

export function entitetIkonForInjisering() {
    return [entitetIkon];
}

/**
 * Viser ikon som representerer angitt entitet type.
 * Bruk: <entitet-ikon type='..type..'></entitet-ikon>
 *
 * Ett av følgene parameter kan angis:
 * @param {string} type typen (det fulle klassenavnet) til entiteten
 */
export function entitetIkon(): IDirective {

    function kalkulerTypeIkon(type: string, $scope) {
        $scope.typeikon = "entitet_ikon_" + somAsciiSmåBokstaver(sisteElementEtter(type, "."));
    }

    return {
        restrict: "E",
        replace: true,
        template: '<i class="entitet_ikon {{typeikon}}"></i>',

        link: function ($scope: IScope, $element: IAugmentedJQuery, $attr: IAttributes) {
            kalkulerTypeIkon($attr["type"], $scope);
            $scope.$watch($attr["type"], (type: string) => {
                kalkulerTypeIkon(type, $scope)
            });
        }
    };
}

